import circle from '@turf/circle';
import union from '@turf/union';

const MAX_ERROR = 25; // km
const MAX_ERROR_UNCERTAIN = 25; // km

export function unionMany(arrayOfPolygons) {
  let output;
  if (arrayOfPolygons.length <= 1) {
    return arrayOfPolygons;
  }

  output = union(arrayOfPolygons[0], arrayOfPolygons[1]);
  for (let i = 2; i < arrayOfPolygons.length; i++) {
    output = union(output, arrayOfPolygons[i]);
  }
  return output;
}

export function buildAccuracyCircles(itemsWithCoords, latestPointIsUncertain = false) {
  const circles = itemsWithCoords
    .filter(({ error }) => error !== null && !Number.isNaN(Number(error)))
    .map(({ latitude, longitude, error }, i) => {
      const circleData = circle(
        [
          parseFloat(longitude),
          parseFloat(latitude),
        ],
        Math.min(
          (error / 1000),
          (latestPointIsUncertain && i === 0 ? MAX_ERROR_UNCERTAIN : MAX_ERROR),
        ),
        { units: 'kilometers', steps: 32 },
      );
      return circleData;
    });

  let features;
  if (circles.length === 1) {
    features = circles;
  } else if (circles.length > 1) {
    try {
      features = [unionMany(circles)];
    } catch (e) {
      // TopologyException can occur when accuracy circles have
      // near-coincident edges (floating-point precision issues in JSTS).
      // Fall back to showing individual circles instead of a merged polygon.
      console.warn('Failed to union accuracy circles, falling back to individual circles:', e.message);
      features = circles;
    }
  } else {
    features = [];
  }

  return {
    type: 'geojson',
    data: {
      id: 'circleData',
      type: 'FeatureCollection',
      features,
    },
  };
}
